export const isOrderItemEligibleForDeliveryMethod = ({
  deliveryMethod,
  item,
}: {
  deliveryMethod?: {
    fulfillmentType?: string | null;
    DeliveryMethodContainerRules?:
      | {
          id: number;
          containerType: string;
          volume: number;
          unit: "gal" | "L" | "ml" | "cl" | "pt" | "oz" | "g" | "kg";
        }[]
      | null;
  };
  item: {
    containerType?: string | null;
    unit?: "gal" | "L" | "ml" | "cl" | "pt" | "oz" | "g" | "kg" | null;
    volume?: number | null;
  };
}) => {
  if (
    !deliveryMethod?.fulfillmentType ||
    !deliveryMethod.DeliveryMethodContainerRules?.length
  ) {
    return true;
  }

  if (!item.containerType) {
    return true;
  }

  return !deliveryMethod.DeliveryMethodContainerRules.some((rule) => {
    if (rule.containerType !== item.containerType) {
      return false;
    }

    if (item.volume !== rule.volume) {
      return false;
    }

    if (item.unit !== rule.unit) {
      return false;
    }

    return true;
  });
};
